import React from 'react'
import styled from 'react-emotion'
import { padding, Loader as StylistLoader } from 'stylist'
import { withProps } from 'recompose'

const Loader = withProps({
  children: <StylistLoader />
})(styled.div`
  ${padding('md')};
  display: flex;
  justify-content: center;
`)

export default Loader



// WEBPACK FOOTER //
// ./src/components/ListBox/Loader.js